<template>
  <section id="admin-filter">
    <h4>Job filter</h4>
    <div class="form-group">
      <label for="job-name" class="form-label">Job Name</label>
      <input type="text" class="form-control" id="jt-name" v-model="entity.jobName"/>
    </div>
    <div class="form-group">
      <label for="job-ref" class="form-label">Job Ref</label>
      <input type="text" class="form-control" id="jt-ref" v-model="entity.jobRef"/>
    </div>
    <div class="form-group">
      <label class="form-label">Origin</label>
      <autocomplete
        :dataset="locationSearchResults"
        title="Origin"
        placeHolder="Type to search"
        :initVal="entity.fromLocation"
        v-on:changing="data => locationSearchText = data"
        :fnFormatText="displayLocation"
        :fnSelectValue="displayLocation"
        v-on:selection-made="selectOrigin"
      ></autocomplete>
    </div>
    <div class="form-group">
      <label class="form-label">Destination</label>
      <autocomplete
        :dataset="locationSearchResults"
        title="Destination Point"
        placeHolder="Type to search"
        :initVal="entity.toLocation"
        v-on:changing="data => locationSearchText = data"
        :fnFormatText="displayLocation"
        :fnSelectValue="displayLocation"
        v-on:selection-made="selectDestination"
      ></autocomplete>
    </div>
    <div class="form-group">
      <label for="job-type" class="form-label">Job Type</label>
      <select class="form-control" id="job-type" v-model="entity.jobType">
        <option :value="null"></option>
        <option v-for="option in jobTypes" :value="option.id">{{ option.name }}</option>
      </select>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import HelperMixin from '../../mixins/Helpers'
  export default {
    name: 'JobFilter',
    mixins: [ FilterMixin, HelperMixin ],
    components: {
      Autocomplete
    },
    data () {
      return {
        entity: {
          fromLocation: '',
          toLocation: '',
          jobType: null,
          jobName: '',
          jobRef: ''
        }
      }
    },
    computed: {
      jobTypes () {
        return this.$store.getters['systemOption/jobTypes'].slice().sort(this.orderByName)
      }
    },
    methods: {
      orderByName (a, b) {
        if (a.name < b.name) {
          return -1
        } else if (a.name > b.name) {
          return 1
        }
        return 0
      },
      selectOrigin (o) {
        this.entity.fromLocation = o
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      selectDestination (d) {
        this.entity.toLocation = d
        this.locationSearchText = ''
        this.locationSearchResults = []
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// JobFilter.vue?77932312